import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    path: '/auctions-settings',
    name: 'settings',
    component: () => import('./pages/SettingsPage.vue'),
    meta: { requiresAdminAuth: true, requiredRole: 'admin', skipAuctionLoad: true },
  },
];
